enum StepNames {
  Recipients = "Recipients",
  Message = "Message",
  Checkout = "Checkout",
  Payment = "Payment"
}

export default StepNames
